import { ClientProfileReportMonth } from 'src/typings';

/** A shared zero baseline keeps losses and empty months honest on the chart. */
export function buildClientProfitChart(months: ClientProfileReportMonth[]) {
  const ordered = [...months].sort((a, b) => a.month_key.localeCompare(b.month_key));
  const min = Math.min(0, ...ordered.map(month => month.profit));
  const max = Math.max(0, ...ordered.map(month => month.profit));
  const range = max - min || 1;
  const y = (value: number) => 20 + ((max - value) / range) * 160;
  const zero = y(0);
  const step = 680 / Math.max(ordered.length, 1);
  return {
    zero,
    ticks: [...new Set([max, (max + min) / 2, min])].map(value => ({ value, y: y(value) })),
    bars: ordered.map((month, index) => ({
      ...month,
      x: 90 + step * (index + 0.5),
      y: Math.min(zero, y(month.profit)),
      height: Math.abs(y(month.profit) - zero),
      width: Math.min(54, step * 0.6),
      label: month.month_key.slice(5) + '.' + month.month_key.slice(2, 4)
    }))
  };
}
